import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id D1558D49-BCE0-4539-9560-DB05153356AF
 * name book-outline
 * version: 3.0.39
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/book-outline.svg
 * tags
 */
export const BookOutlineIcon = createSvgIcon(<><path d="M18,2A2,2 0 0,1 20,4V20A2,2 0 0,1 18,22H6A2,2 0 0,1 4,20V4A2,2 0 0,1 6,2H18M18,4H13V12L10.5,9.75L8,12V4H6V20H18V4Z" /></>, 'BookOutlineIcon');
export default BookOutlineIcon